// Auth API calls. All return the response body (or throw an axios error the caller can read).
import { api } from './client.js';

// Step 1 of login: email + password. On success a one-time code is emailed (returns { otpRequired }).
export const login = (email, password) => api.post('/auth/login', { email, password }).then((r) => r.data);

export const verifyOtp = (email, code) =>
  api.post('/auth/verify-otp', { email, code }).then((r) => r.data);

// Invitation registration (public).
export const validateInvite = (token) => api.get(`/auth/invite/${token}`).then((r) => r.data);
export const registerAccount = (token, password) =>
  api.post('/auth/register', { token, password }).then((r) => r.data);

// Forgot password: request a set-new-password link by email (always resolves; no enumeration).
export const requestPasswordReset = (email) =>
  api.post('/auth/request-password-reset', { email }).then((r) => r.data);

export const logoutRequest = () => api.post('/auth/logout').then((r) => r.data);

export const fetchMe = () => api.get('/auth/me').then((r) => r.data);

export const fetchProviders = () => api.get('/auth/providers').then((r) => r.data);

// Google sign-in is a full-page navigation to the server, not an XHR.
export const GOOGLE_LOGIN_URL = '/api/auth/google';
